export enum FlipBackOptions {
  LocateHistory = 1,
  ProductProblems = 2
}

export enum LpnState {
  Created = 1,
  Pending = 2,
  Finished = 3,
  Manage = 4 // Gestionar
}

export const eTypePosition = {
  VTA: 1, // Ubicación de Venta
  TRA: 2, // Ubicación de Transito
  PAC: 3, // Ubicación de Packing
  MER: 4, // Ubicación de Merma
  DIF: 5, // Ubicación de Diferencia
  REC: 6, // Ubicación de Recepción
  DESP: 7, // Ubicación de Despacho
  PDESP: 8, // Ubicación de Pre-Despacho
  ENTF: 9, // Ubicación de Entrada Fotografia
  SALF: 10, // Ubicación de Salida Fotografia
  PROB: 11, // Ubicación de Problema
  DEVP: 12, // Ubicacion Devolución Proveedor
  CANC: 13, // Ubicacion Cancelación
  ALM: 14, // Ubicación de Almacenamiento
  DREC: 15, // Ubicación Recepción Devolución
  PPC: 16, // Ubicación Pedido Por Completar
  REP: 17, // Ubicación de Reposición
  DRAFT: 18, // Ubicación de Borrador
  CLDAD: 19, // Ubicación de Calidad
  CLDREC: 20, // Ubicación Calidad Recepción
  CLDVAL: 21, // Ubicación de Calidad-Validación
  CLVALDF: 22, // Ubicación de Calidad-Validación-Draft
  CLDDEV: 23, // Ubicación de Calidad-Devolución
  CLDEVDF: 24, // Ubicación de Calidad-Devolución-Draft
  STGSAL: 25, // Ubicación de Staging-Salida
  CLDTRA: 26, // Ubicación de Calidad-Transferencia
  CLDPAC: 27, // Ubicación de Calidad-Packing
  RESDF: 28, // Ubicación de Reserva-Draft
  RES: 29, // Ubicación de Reserva
  DIFDF: 30, // Ubicación de Diferencia-Draft
  CLDTRADF: 31, // Ubicación de Calidad-Transferencia-Draft
  CLDRCL: 32, // Ubicación de Calidad-Recall
  PREREC: 33, // Ubicación de Pre-Recepción
  RM: 34, // Ubicación de Rechazo Comercial
  VTAVRD: 35 // Ubicación de Venta En Verde
} as const

type eTypePosition = (typeof eTypePosition)[keyof typeof eTypePosition]
